import { getAPI } from '@/utils/api'
import { getLocal, setLocal, resetLocal } from '@/utils/globalState'
const user = {
  namespace: true,
  state: {
    token: getLocal('token'),
    name: '',
    storeInfo: null,
    themeColor: getLocal('themeColor', null, 'teal'),
    devtoken: getLocal('devtoken')
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_DEVTOKEN: (state, devtoken) => {
      state.devtoken = devtoken
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_STORE_INFO: (state, storeInfo) => {
      state.storeInfo = storeInfo
    },
    SET_THEME: (state, theme) => {
      state.themeColor = theme
    }
  },
  actions: {
    // 登入 action只能吃一個payload
    Login ({ commit }, userInfo) {
      const api = getAPI()
      userInfo.userid = userInfo.userid.trim()
      return new Promise((resolve, reject) => {
        api.login(userInfo).then(response => {
          if (response.result === 'OK') {
            // const { token, STOCK_NO } = response.data
            const { token, devtoken } = response.data
            setLocal('token', token)
            setLocal('devtoken', devtoken)
            // setLocal('stock_no', STOCK_NO)
            commit('SET_TOKEN', token)
            commit('SET_DEVTOKEN', devtoken)
            resolve({ token })
          } else {
            reject(response.msg)
          }
        }).catch(error => {
          // error 是完整的{result,msgCode,msg}結構
          reject(error.msg)
        })
      })
    },
    // 登出
    LogOut ({ commit }, state) {
      // const api = getAPI()
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_DEVTOKEN', '')
        resetLocal()
        resolve()
      })
    },
    // 取得店家資訊
    GetInfo ({ commit }, state) {
      const api = getAPI()
      return new Promise((resolve, reject) => {
        api.getInfo().then(response => {
          commit('SET_STORE_INFO', response.data)
          resolve(response)
        }).catch(e => {
          console.log('GetInfo error==')
          console.log(e)
          reject(e)
        })
      })
    },
    SetTheme ({ commit }, state) {
      commit('SET_THEME', state)
      setLocal('themeColor', state)
    }
  }
}
export default user
